import HeroSection from './components/HeroSection';
import DestinationCards from './components/DestinationCards';
import CategoryNav from './components/CategoryNav';
import ArticleList from './components/ArticleList';
import NewsletterSection from './components/NewsletterSection';

export default function Home() {
  return (
    <main>
      <article>
        <HeroSection />
        <DestinationCards />
        <CategoryNav />
        <ArticleList />
        <NewsletterSection />
      </article>

      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebSite",
          "name": "亚洲天堂",
          "url": "https://rstuwlw.cn",
          "description": "亚洲天堂汇聚亚洲最令人心动的旅行胜地与度假体验，提供最全面的亚洲旅游攻略、目的地推荐与出行规划。",
          "potentialAction": {
            "@type": "SearchAction",
            "target": "https://rstuwlw.cn/search?q={search_term_string}",
            "query-input": "required name=search_term_string"
          },
          "inLanguage": "zh-Hans"
        })
      }} />
    </main>
  );
}